const HotelAmenitiesFilter = [
  'pornographic',
];

export default HotelAmenitiesFilter;
